/* roymebuis — Offerta 1 / 2 / 3 pezzi (vedi snippets/rm-bundle.liquid) */
(function () {
  if (window.__rmbBound) return;
  window.__rmbBound = true;

  var st = null;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function money(cents, fmt) {
    fmt = fmt || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var intDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var intCom = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_with_comma_separator') return intDot + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return intDot;
      if (k === 'amount_no_decimals') return intCom;
      return intCom + '.' + parts[1];
    });
  }

  function currentMainId() {
    var i = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    return i ? String(i.value) : null;
  }

  function init() {
    var root = document.querySelector('[data-rmb]');
    if (!root || root.getAttribute('data-rmb-ready') === '1') return;
    root.setAttribute('data-rmb-ready', '1');

    var data = { variants: [] };
    try { data = JSON.parse(root.querySelector('[data-rmb-data]').textContent); } catch (e) {}
    var byId = {}, ids = [];
    (data.variants || []).forEach(function (v) { byId[String(v.id)] = v; ids.push(String(v.id)); });
    var off = { 1: 0, 2: parseInt(root.getAttribute('data-off2'), 10) || 0, 3: parseInt(root.getAttribute('data-off3'), 10) || 0 };
    var opts = [].slice.call(root.querySelectorAll('.rmb__opt'));
    var touched = false;

    function selected() { return root.querySelector('.rmb__opt.is-on') || opts[0]; }
    function qty() { return parseInt(selected().getAttribute('data-qty'), 10) || 1; }

    function pieces(o) {
      var n = parseInt(o.getAttribute('data-qty'), 10) || 1;
      var sels = o.querySelectorAll('[data-rmb-sel]');
      var main = currentMainId() || ids[0];
      var out = [];
      for (var i = 0; i < n; i++) out.push(sels[i] ? String(sels[i].value) : main);
      return out;
    }

    function totals(o) {
      var n = parseInt(o.getAttribute('data-qty'), 10) || 1;
      var p = 0, c = 0;
      pieces(o).forEach(function (id) {
        var v = byId[id]; if (!v) return;
        p += v.p; c += Math.max(v.c || 0, v.p);
      });
      return { now: p - off[n], was: c };
    }

    function items() {
      var rows = [];
      pieces(selected()).forEach(function (id) {
        var r = null;
        rows.forEach(function (x) { if (x.id === id) r = x; });
        if (r) r.quantity += 1; else rows.push({ id: id, quantity: 1 });
      });
      return rows.map(function (r) { return { id: parseInt(r.id, 10), quantity: r.quantity }; });
    }

    function paint() {
      opts.forEach(function (o) {
        var t = totals(o);
        var now = o.querySelector('[data-rmb-now]'), was = o.querySelector('[data-rmb-was]');
        if (now) now.textContent = money(t.now, data.fmt);
        if (was) { was.textContent = money(t.was, data.fmt); was.hidden = !(t.was > t.now); }
      });
      var t = totals(selected());
      var html = (t.was > t.now ? '<s>' + money(t.was, data.fmt) + '</s> ' : '') + money(t.now, data.fmt);
      var bp = document.querySelectorAll('product-form .product-form__submit .nps-bp');
      for (var i = 0; i < bp.length; i++) bp[i].innerHTML = '– ' + html;
      var sb = document.querySelectorAll('[data-nps-btnprice]');
      for (var j = 0; j < sb.length; j++) sb[j].innerHTML = html;
      document.body.classList.toggle('rmb-multi', qty() > 1);
    }

    function syncMain() {
      if (touched) return;
      var main = currentMainId(); if (!main || !byId[main] || !byId[main].ok) return;
      [].forEach.call(root.querySelectorAll('[data-rmb-sel]'), function (s) { s.value = main; });
    }

    function refresh() { syncMain(); paint(); }
    function refreshSoon() { [80, 700, 1400, 2700].forEach(function (t) { setTimeout(refresh, t); }); }

    function choose(o) {
      opts.forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      paint();
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function (e) { if (e.target.closest('select, label') && o.classList.contains('is-on')) return; choose(o); });
      o.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === o) { e.preventDefault(); choose(o); } });
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-rmb-sel]')) { touched = true; paint(); }
    });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.nps-color, variant-selects')) refreshSoon(); });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) refreshSoon(); });

    st = { ids: ids, qty: qty, items: items };
    refreshSoon();
  }

  var busy = false;
  function add(btn) {
    var it = st.items();
    if (busy || !it.length) return;
    busy = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: it };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var sp = btn && btn.querySelector('.loading__spinner');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (sp) sp.classList.remove('hidden');
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { window.alert(res.description || res.message || 'Articolo non disponibile.'); return; }
        if (cart && cart.renderContents && res && res.sections) {
          cart.renderContents(res);
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else window.location.href = base + 'cart';
      })
      .catch(function () { window.location.href = base + 'cart'; })
      .then(function () {
        busy = false;
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        if (sp) sp.classList.add('hidden');
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!st || !f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    var i = f.querySelector('[name="id"]');
    if (!i || st.ids.indexOf(String(i.value)) === -1) return;
    if (st.qty() < 2) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    add(f.querySelector('[type="submit"]') || (f.closest('product-form') || f).querySelector('[type="submit"]'));
  }, true);

  var css = document.createElement('style');
  css.textContent = 'body.rmb-multi .shopify-payment-button{display:none!important;}';
  document.head.appendChild(css);

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
  ready(init);
})();
